import { Box, styled } from '@mui/material';
var StyledModalContainer = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  var styles = {
    padding: theme.spacing(0),
    borderRadius: theme.typography.pxToRem(16)
  };
  return styles;
});
export { StyledModalContainer };